module.exports = __webpack_public_path__ + "static/media/29DUNON1.d51e4df6.jpg";